import { render, staticRenderFns } from "./AdvertiseConfirmAction.vue?vue&type=template&id=3edf4c96&scoped=true"
import script from "./AdvertiseConfirmAction.vue?vue&type=script&lang=js"
export * from "./AdvertiseConfirmAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edf4c96",
  null
  
)

export default component.exports